import DeleteLessonPlan from "./DeleteLessonPlan";

export default DeleteLessonPlan